import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { ScheduleV2 } from '@frontend/api-schedule-v2';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useTranslation } from '@frontend/i18n';
import { useScheduleWaitlistNotification } from '@frontend/notifications';
import { handleWaitlistAppointmentNotificationClick } from '@frontend/schedule';
import { GetWeavePopNotificationByType } from '@frontend/types';
import { useWebsocketEventSubscription } from '@frontend/websocket';

export const useWebsocketScheduleWaitlistUpdateEventSubscription = () => {
  const { t } = useTranslation('notifications');
  const { create } = useScheduleWaitlistNotification(handleWaitlistAppointmentNotificationClick);
  const { invalidateWaitlistList, invalidateWaitlistCount } = ScheduleV2.Helpers.useScheduleV2InvalidateQueries();
  const {
    invalidateListCalendarEvents,
    invalidateListCalendarEventsByAttendee,
    invalidateListScheduleActivity,
    invalidateListScheduleActivityHistory,
  } = SchedulerV3.Helpers.useSchedulerV3InvalidateQueries();

  return useWebsocketEventSubscription(NotificationType.SCHEDULE_WAITLIST_UPDATE, (payload) => {
    if (payload.params.status !== 'BOOKED') return;

    const notification = {
      id: payload.id,
      timestamp: Date.now(),
      type: 'schedule-waitlist',
      payload: payload.params,
      state: {
        paused: false,
        status: 'unread',
      },
    } satisfies GetWeavePopNotificationByType<'schedule-waitlist'>;

    create(notification, {
      os: {
        title: t('New Appointment Booked from Waitlist'),
        body: payload.params.inviteeName ?? '',
      },
    });

    const locationId = payload.params.locationId;

    // invalidate waitlist & calnendar events
    invalidateWaitlistList(locationId);
    invalidateWaitlistCount(locationId);
    invalidateListCalendarEvents({
      locationId,
      startDateTime: payload.params.startTime,
      endDateTime: payload.params.endTime,
    });
    invalidateListCalendarEventsByAttendee(locationId);
    invalidateListScheduleActivity({ locationId });
    invalidateListScheduleActivityHistory({ locationId });
  });
};
